import type { IFieldConfig, IFieldOption } from "./types";

type TOverrides = Partial<Omit<IFieldConfig, "name" | "type">>;

const base = (type: IFieldConfig["type"], name: string, label: string, over?: TOverrides): IFieldConfig => ({
  name,
  label,
  type,
  gridXs: 6,
  ...over,
});

export const f = {
  text: (name: string, label: string, over?: TOverrides) => base("input", name, label, over),
  number: (name: string, label: string, over?: TOverrides) =>
    base("input", name, label, { inputType: "number", ...over }),
  email: (name: string, label: string, over?: TOverrides) =>
    base("input", name, label, { inputType: "email", ...over }),
  tel: (name: string, label: string, over?: TOverrides) =>
    base("input", name, label, { inputType: "tel", ...over }),
  password: (name: string, label: string, over?: TOverrides) =>
    base("input", name, label, { inputType: "password", ...over }),
  textarea: (name: string, label: string, rows = 3, over?: TOverrides) =>
    base("input", name, label, { gridXs: 12, props: { multiline: true, rows }, ...over }),

  date: (name: string, label: string, over?: TOverrides) => base("date", name, label, over),

  select: (name: string, label: string, options: IFieldOption[], over?: TOverrides) =>
    base("select", name, label, { options, ...over }),

  autocomplete: (name: string, label: string, options: IFieldOption[], over?: TOverrides) =>
    base("autocomplete", name, label, { options, ...over }),

  checkbox: (name: string, label: string, over?: TOverrides) =>
    base("checkbox", name, label, { gridXs: 12, ...over }),

  switch: (name: string, label: string, over?: TOverrides) =>
    base("switch", name, label, { gridXs: 12, ...over }),

  radio: (name: string, label: string, options: IFieldOption[], over?: TOverrides) =>
    base("radio", name, label, { options, gridXs: 12, ...over }),

  currency: (name = "currency", label = "Currency", over?: TOverrides) =>
    base("currency", name, label, over),

  country: (name: string, label: string, over?: TOverrides) => base("country", name, label, over),

  customerLookup: (over?: TOverrides) =>
    base("customerLookup", "customerCompanyName", "companyName", { gridXs: 12, ...over }),

  vendorLookup: (over?: TOverrides) =>
    base("vendorLookup", "vendorCompanyName", "companyName", { gridXs: 12, ...over }),

  custom: (name: string, label: string, customKey: string, over?: TOverrides) =>
    base("custom", name, label, { customKey, ...over }),

  siiCorrectionCode: (over?: TOverrides) =>
    base("select", "spainCorrectionCode", "SpainCorrectionCode", {
      options: [
        { value: "R1", label: "R1 → Rectificativa (error fundado en derecho) + art. 80.1, 80.2 and 80.6" },
        { value: "R2", label: "R2 → Rectificativa (art. 80.3)" },
        { value: "R3", label: "R3 → Rectificativa (art. 80.4)" },
        { value: "R4", label: "R4 → Rectificativa (resto casos)" },
        { value: "R5", label: "R5 → Rectificativa en facturas simplificadas" },
      ],
      ...over,
    }),
};

export type FieldFactory = typeof f;
